import { combineReducers } from 'redux';
import admin from '../reducer/adminReducers';
import tags from '../tags/reducer/tagsReducer';

export default combineReducers({
  admin,
  tags,
});
